import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { AngularSvgIconModule } from 'angular-svg-icon';
import { MatDialogModule } from '@angular/material/dialog';
import { TranslateModule } from '@ngx-translate/core';
import { JobseekerLanguageComponent } from './jobseeker-language/jobseeker-language.component';
import { UiModule } from '@hrra/ui';
import { JobseekerDocumentComponent } from './jobseeker-document/jobseeker-document.component';
import { JobseekerEducationComponent } from './jobseeker-education/jobseeker-education.component';
import { JobseekerPersonalInfoComponent } from './jobseeker-personal-info/jobseeker-personal-info.component';
import { JobseekerPhotoComponent } from './jobseeker-photo/jobseeker-photo.component';
import { JobseekerWorkExperienceComponent } from './jobseeker-work-experience/jobseeker-work-experience.component';
import { JobseekerProfileTileComponent } from './jobseeker-profile-tile/jobseeker-profile-tile.component';
import { AnnouncementLocationComponent } from './announcement-location/announcement-location.component';
import { JobseekerLocationComponent } from './jobseeker-location/jobseeker-location.component';
import { CommonModelsModule } from '@hrra/common-models';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatSelectModule } from '@angular/material/select';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import {
  MAT_FORM_FIELD_DEFAULT_OPTIONS,
  MatFormFieldModule,
} from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { LocationPickerComponent } from './location-picker/location-picker.component';
import { TreeSelectComponent } from './tree-select/tree-select.component';
import { TreeSelectModule } from 'primeng/treeselect';
import { LocationTreeSelectComponent } from './location-tree-select/location-tree-select.component';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { FiltersModule } from './filters/filters.module';
import { SpecializationTreeSelectComponent } from './specialization-tree-select/specialization-tree-select.component';
import { IndustryTreeSelectComponent } from './industry-tree-select/industry-tree-select.component';
import { TreeSelectSpinnerComponent } from './tree-select-spinner/tree-select-spinner.component';
import { SelectModule } from 'primeng/select';
import { PasswordComponent } from './password/password.component';
import { AnnouncementDetailsTileComponent } from './announcement-details-tile/announcement-details-tile.component';
import { SkillsComponent } from './skills/skills.component';
import { JobseekerSkillsEditFormComponent } from './jobseeker-skills-edit-form/jobseeker-skills-edit-form.component';
import { SkillsFilterComponent } from './skills-filter/skills-filter.component';
import { SkillsFilterDialogComponent } from './skills-filter/skills-filter-dialog.component';
import { DragDropModule } from '@angular/cdk/drag-drop';

@NgModule({
  declarations: [
    JobseekerLanguageComponent,
    JobseekerDocumentComponent,
    JobseekerEducationComponent,
    JobseekerPersonalInfoComponent,
    JobseekerPhotoComponent,
    JobseekerWorkExperienceComponent,
    JobseekerProfileTileComponent,
    JobseekerLocationComponent,
    LocationPickerComponent,
    AnnouncementLocationComponent,
    TreeSelectComponent,
    LocationTreeSelectComponent,
    IndustryTreeSelectComponent,
    SpecializationTreeSelectComponent,
    TreeSelectSpinnerComponent,
    PasswordComponent,
    AnnouncementDetailsTileComponent,
    SkillsComponent,
    JobseekerSkillsEditFormComponent,
    SkillsFilterComponent,
    SkillsFilterDialogComponent

  ],
  imports: [
    CommonModule,
    RouterModule,
    AngularSvgIconModule,
    MatDialogModule,
    TranslateModule,
    UiModule,
    CommonModelsModule,
    MatAutocompleteModule,
    MatSelectModule,
    FormsModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    MatInputModule,
    MatCheckboxModule,
    TreeSelectModule,
    ProgressSpinnerModule,
    SelectModule,
    FiltersModule,
    DragDropModule,
  ],
  exports: [
    JobseekerLanguageComponent,
    JobseekerDocumentComponent,
    JobseekerEducationComponent,
    JobseekerPersonalInfoComponent,
    JobseekerPhotoComponent,
    JobseekerWorkExperienceComponent,
    JobseekerProfileTileComponent,
    JobseekerLocationComponent,
    LocationPickerComponent,
    AnnouncementLocationComponent,
    TreeSelectComponent,
    LocationTreeSelectComponent,
    PasswordComponent,
    SpecializationTreeSelectComponent,
    IndustryTreeSelectComponent,
    AnnouncementDetailsTileComponent,
    SkillsComponent,
    JobseekerSkillsEditFormComponent,
    SkillsFilterComponent,
    SelectModule,
    FiltersModule,
  ],
})
export class CommonComponentsModule {}
